export default "__VITE_ASSET__DtnoT66q__"